import React from "react";
import { Link } from "react-router-dom";
import HighlightedText from "../HighlightedText";

export function LinkInterestedParties (props) {
  return (
  <>
  <span title={props.rowData[props.field] && Array.isArray(props.rowData[props.field]) ? props.rowData[props.field].join(", ") : props.rowData[props.field]}>
  {props.rowData[props.field] &&
     Array.isArray(props.rowData[props.field]) &&
     props.rowData[props.field].slice(0, 2).map((data, i, array) => (
       <Link
         style={{ textDecoration: "none", color: "#fff" }}
         key={i}
         aria-label={data}
        //  title={data}
         to={           
           {
            pathname: `/search/${props.type}/${encodeURI(data.trim().replace("/", ""))}/${props.field}`,
            state:{
            q:`${data.trim()}`,
            autofocus:false
            }
          }
          }
       >
         <strong class="tablesLink">
           <span
             dangerouslySetInnerHTML={{
               __html:
               props.highlights && typeof props.highlights[i] === "string"
                   ? props.highlights[i]
                       .replaceAll("<", "&lt;")
                       .replaceAll(">", "&gt;")
                       .replaceAll(
                         "⌌",
                         "<span style='background-color: #ffeeb9;color:black;'>"
                       )
                       .replaceAll("⌍", "</span>")
                   : data,
             }}
           ></span>
           {i === array.length - 1 ? null : ", "}
         </strong>
       </Link>
     ))}
     {props.rowData[props.field] &&
     !Array.isArray(props.rowData[props.field]) &&
     
       <Link
         style={{ textDecoration: "none", color: "#fff" }}
         key={props.rowData[props.field]}
         aria-label={props.rowData[props.field]}
        //  title={data}
         to={
          {
            pathname: `/search/${props.type}/${encodeURI(props.rowData[props.field].trim().replace("/", ""))}/${props.field}`,
            state:{
            q:`${props.rowData[props.field].trim()}`,
            autofocus:false
            }
          }
         }
       >
         <strong class="tablesLink">
         {HighlightedText(props.rowData, props.field)}
         </strong>
       </Link>
     }
     </span>
     </>
  )
 }
